import {
  Pipe,
  PipeTransform,
  ChangeDetectorRef,
  OnDestroy,
  inject,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { TranslateService } from './translate.service';
import { formatLocaleNumber } from './locale-number.util';

/**
 * Locale-aware number formatting based on TranslateService language.
 * TR → 0,2  |  EN → 0.2
 *
 * {{ value | localeNumber:1 }}
 * {{ value | localeNumber:2 }}
 */
@Pipe({
  name: 'localeNumber',
  pure: false,
  standalone: true,
})
export class LocaleNumberPipe implements PipeTransform, OnDestroy {
  private readonly translate = inject(TranslateService);
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly sub: Subscription;

  private lastValue?: number | null;
  private lastDigits?: number;
  private lastLang?: string;
  private lastResult = '';

  constructor() {
    this.sub = this.translate.languageChange.subscribe(() => {
      this.lastLang = undefined;
      this.cdr.markForCheck();
    });
  }

  transform(
    value: number | null | undefined,
    fractionDigits = 0
  ): string {
    const lang = this.translate.getCurrentLanguage();
    const digits = Math.max(0, Math.floor(fractionDigits));

    if (
      this.lastValue === value &&
      this.lastDigits === digits &&
      this.lastLang === lang
    ) {
      return this.lastResult;
    }

    this.lastValue = value;
    this.lastDigits = digits;
    this.lastLang = lang;
    this.lastResult = formatLocaleNumber(value, digits, lang);
    return this.lastResult;
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}
